import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  getUsers,
  getUser,
  createUser,
  updateUser,
  deleteUser,
} from '../api/admin-users';

/**
 * Get Paginated Blogs
 */
export const useUsers = (page = 1, limit = 10, apiFilter) => {
  return useQuery({
    queryKey: ['users', page, limit, JSON.stringify(apiFilter)],
    queryFn: () => getUsers(page, limit, apiFilter),
    keepPreviousData: true,
  });
};

/**
 * Get Single Blog by ID
 */
export const useUser = (id) => {
  return useQuery({
    queryKey: ['user', id],
    queryFn: () => getUser(id),
    enabled: !!id,
  });
};

/**
 * Create Blog
 */
export const useCreateUser = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
};

/**
 * Update Blog
 */
export const useUpdateUser = ({ id, body }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }) => updateUser(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['user', id] });
    },
  });
};

/**
 * Delete Blog
 */
export const useDeleteBlog = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteUser,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });
};
